exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.backButton[data-v-4f3bbb26]{color:inherit;text-decoration:none;position:absolute;top:3em}a.backButton[data-v-4f3bbb26]:hover{color:#2aacea}a.backButton i[data-v-4f3bbb26]{margin-right:6px}p[data-v-4f3bbb26]{max-width:800px;margin:auto}", ""]);

// exports
